import request from '@/utils/request'


/**
 * 制作招标文件相关接口
 */
// 获取招标文件正文
export const getInvitationMain = (sectionCode) => {
    return request.get('/api/bid/make/invitation/main?bidSectionCode=' + sectionCode)
}
// 获取招标文件附件列表
export const getInvitationAttList = (sectionCode) => {
    return request.get('/api/bid/make/invitation/att?bidSectionCode=' + sectionCode)
}
//获取招标文一览表
export const getOpeningSummaryList = (sectionCode) => {
    return request.get('/api/bid/make/opening/list?bidSectionCode=' + sectionCode)
}
// 投标-上传文件附件信息
export const uploadBidAtt = (data) => {
    return request.post('/api/bid/make/upload/att', data)
}

// 投标-获取文件附件列表(新)
export const getBidAttList = (sectionCode) => {
    return request.get('/api/bid/make/att/list?bidSectionCode=' + sectionCode)
}

// 投标-删除文件附件
export const deleteBidAtt = (fileId) => {
    return request.get('/api/bid/make/att/delete?fileId=' + fileId)
}

//投标-获取文件正文
export const getBidMain = (sectionCode,isBlindReview) => {
    return request.get('/api/bid/make/main?bidSectionCode=' + sectionCode+'&isBlindReview='+isBlindReview)
}
// 投标-删除文件正文


export const deleteBidMain = (fileId) => {
    return request.get('/api/bid/make/att/delete?fileId=' + fileId)
}
//上传正文
export const uploadBidSign = (data) => {
    return request.post('/api/bid/make/upload/sign', data)
}




//招标一览表详情新增
export const addOpeningSummary = (data) => {
    return request.post('/api/bid/make/opening/add', data)
}
//招标-树状列表(目录)
export const getInvitationCatalogue =(sectionCode,isBlindReview)=>{
     return request.get('/api/bid/make/invitation/catalogue?bidSectionCode=' + sectionCode+'&isBlindReview='+isBlindReview)
    
}
///招标-树状列表-关联
export const getBidCatalogue =(data)=>{
     return request.post('/api/bid/make/catalogue/ref', data)
    
}
//投标-上传文件（签章）正文信息
export const uploadBidSignMain = (data) => {
    return request.post('/api/bid/make/upload/bid/sign/main', data)
}
//获取密钥
export const getBidKey =(sectionCode)=>{
     return request.get('/api/bid/make/key?bidSectionCode=' + sectionCode)
    
}
//更新秘钥
export const updateBidKey = (data) => {
    return request.post('/api/bid/make/key/update', data)
}

//投标-获取秘钥状态
export const getBidKeyState =(sectionCode)=>{
     return request.get('/api/bid/make/key/state?bidSectionCode=' + sectionCode)
    
}
//投标文件制作完成
export const finishBidMake = (data) => {
    return request.post('/api/bid/make/finish', data)
}
///澄清-补遗文件文件列表
export const getEvaluationAgentFile =(id)=>{
     return request.get('/api/evaluation/agent/file?id='+id)
    
}
//获取密钥
export const getBidKeyInfo = (sectionCode) => {
    return request.get('/api/bid/make/get/key?sectionCode=' + sectionCode)
}
//保存 证书信息
export const saveKeyInfo = (data) => {
    return request.post('/api/bid/make/save/key',data)
}


// 获取一次性Token
export const getOneTimeToken = (fileId) => {
    return request.get('/api/file/onetime/token?fileId='+fileId)
}

// 获取一次性URL
export const getOneTimeUrl = (token) => {
    return request.get('/api/file/onetime/url/' + token)
}







